export class Role {

    constructor(
        public name: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/classes/role.ts